import React, { useContext } from "react";
import { ThemeContext } from "../../context/ThemeContext";
import { Link } from "gatsby";
import LogoRoomCloud from "../../assets/img/svg/logo-roomcloud.svg";

import "./style.scss";

const Footer = () => {
  const theme = useContext(ThemeContext);

  return (
    <footer>
      <div className="inner-footer">
        <div className="columns is-multiline m-0">
          <div className="column is-offset-1-tablet is-2-tablet contacts">
            <Link to="/come-funziona">Come funziona</Link>
            <br />
            <br />
            <Link to="/perche-eucleia/">Perché Eucleia</Link>
            <br />
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://docs.acmeproduzioni.it/eucleia-website/privacy-policy-it.html"
            >
              Privacy Policy
            </a>
          </div>
          <div className="column is-2-tablet pages">
            <Link to="/le-nostre-integrazioni">Le nostre integrazioni</Link>
            <br />
            <br />
            <Link to="/agenti-ai/">Agenti AI</Link>
            <br />
            <br />
            <Link to="/brand-reputation/">Brand reputation</Link>
            <br />
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://docs.acmeproduzioni.it/eucleia-website/cookie-policy-it.html"
            >
              Cookie Policy
            </a>
          </div>
          <div className="column is-2-tablet">
            <Link to="/news/">News</Link>
            <br />
            <br />
            <Link to="/contatti">Contatti</Link>
            <br />
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://customers.acmeproduzioni.it"
            >
              Login
            </a>
          </div>
          <div className="column is-offset-2-tablet is-offset-2-desktop is-8-tablet is-3-desktop">
            <div className="columns is-gapless social">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/acmeproduzioni/"
                className="column is-3 is-full-mobile"
              >
                <span style={{ fontWeight: "bold" }}>Facebook</span>
              </a>
              <br />
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.instagram.com/acmeproduzioni_official/"
                className="column is-9 is-full-mobile"
              >
                <span style={{ fontWeight: "bold" }}>Instagram</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="sub-footer">
        <div className="columns m-0">
          <div className="column is-offset-1-tablet is-8-tablet ">
            <span>
              © {theme.currentYear} Eucleia by{" "}
              <a href="https://acmeproduzioni.it/" target="_blank">
                ACME Produzioni Srl
              </a>{" "}
              - PIVA/VAT 10245151005
            </span>
          </div>
          <div className="column is-2-tablet ">
            <div className="columns is-mobile">
              <div className="column"></div>
              <div className="column"></div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
